<template>
	<v-dialog
			v-model="show"
			content-class="rounded-xl"
			persistent
			scrollable
			width="600px"
	>
		<v-card class="position-relative" rounded="xl">
			<v-card-title class="d-flex justify-space-between ma-0 ma-md-4">
				<div class="w-100">
					<div class="align-center d-flex justify-space-between">
						<h6>Unsaved Changes</h6>
					</div>
				</div>
			</v-card-title>
			<v-card-text class="text-body-2">

				<v-row>
					<v-col>
						Your changes have not been saved. Leaving now will discard them.
					</v-col>
				</v-row>

			</v-card-text>

			<v-card-actions>
				<div class="align-center d-flex justify-space-between w-100">
					<span></span>
					<div class="d-flex justify-end">
						<v-btn
								class="me-2 me-md-4 rounded-lg"
								color="grey darken-1"
								depressed
								:href="navigatingTo.fullPath"
								:large="$vuetify.breakpoint.mdAndUp"
								outlined
						>
							Leave
						</v-btn>
						<v-btn
								class="rounded-lg"
								color="primary"
								depressed
								:large="$vuetify.breakpoint.mdAndUp"
								@click="clearNavState"
						>
							Stay on Page
						</v-btn>
					</div>
				</div>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
	name: 'UnsavedChanges',
	props: {},
	data() {
		return {
			show: false
		};
	},
	computed: {
		...mapGetters('formState', { isDirty: 'getIsDirty' }),
		...mapGetters('navState', { navigatingTo: 'getNavState' })
	},
	methods: {
		...mapActions('navState', ['clearNavState']),
		updateShowState(isDirty, navigatingTo) {
			// Logic to set this.show based on isDirty and navigatingTo
			this.show = isDirty && navigatingTo;
		}
	},
	watch: {
		isDirty(newIsDirty) {
			this.updateShowState(newIsDirty, this.navigatingTo);
		},
		navigatingTo(newNavigatingTo) {
			this.updateShowState(this.isDirty, newNavigatingTo);
		}
	}
};

</script>

<style lang="scss"></style>
